import CameraTab from './CameraTab.vue';
export default CameraTab;
